import {put, takeEvery, call, select} from 'redux-saga/effects';
import {
    FEEDBACK_QUALITY_GET,
    FEEDBACK_QUALITY_GET_REQUEST,
    FEEDBACK_QUALITY_GET_SUCCESS,
    FEEDBACK_QUALITY_GET_FAILURE
} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {shouldLoadTeam} from '../../utils';
import {userRole} from '../selectors/selector';
import {GetFeedbackAction} from './typedef';
import {Profile} from 'feedback-system/dto/IProfile';
import {Feedback} from 'feedback-system/dto/IFeedback';

function* qualityFeedbackSetData(action: GetFeedbackAction) {
    const {periodId} = action.payload;
    const roles = yield select(userRole);
    const loadTeam = shouldLoadTeam(roles);
    let teamData;
    try {
        yield put({type: FEEDBACK_QUALITY_GET_REQUEST});

        if (loadTeam) {

            const teamProfiles = (yield call(Api.fetch, {
                endpoint: 'profiles/team',
                method: ApiMethods.GET
            })).responseData;

            const teamProfilesIds = teamProfiles.map((profile: Profile) => profile.id);

            const teamFeedbacks = (yield call(Api.fetch, {
                endpoint: `feedback/team/${periodId}`,
                method: ApiMethods.POST,
                body: teamProfilesIds
            })).responseData;

            const teamCount = (yield call(Api.fetch, {
                endpoint: `feedback/count/${periodId}`,
                method: ApiMethods.POST,
                body: teamProfilesIds
            })).responseData;

            const teamNewCount = (yield call(Api.fetch, {
                endpoint: `feedback/new/count/${periodId}`,
                method: ApiMethods.POST,
                body: teamProfilesIds
            })).responseData;

            teamData = teamProfiles.map((profile: Profile) => {
                const feedback = teamFeedbacks.find((f: Feedback) => f.recipientId === profile.id);
                return {
                    profile,
                    feedbacks: feedback ? [feedback] : [],
                    ...(teamCount[profile.id] ? {otherFeedbackCount: teamNewCount[profile.id] || 0} : null)
                };
            });
        }

        const optionalProfiles = (yield call(Api.fetch, {
            endpoint: 'profiles/temporary',
            method: ApiMethods.GET
        })).responseData;

        const optionalFeedbacks = (yield call(Api.fetch, {
            endpoint: `feedback/temporary/${periodId}`,
            method: ApiMethods.POST,
            body: optionalProfiles.map((profile: Profile) => profile.id)
        })).responseData;

        const optionalData = optionalProfiles.map((profile: Profile) => {
            const feedback = optionalFeedbacks.find((f: Feedback) => f.recipientId === profile.id);
            return {
                profile,
                feedbacks: feedback ? [feedback] : []
            };
        });

        if (loadTeam) {
            yield put({type: FEEDBACK_QUALITY_GET_SUCCESS, optionalData, teamData});
        } else {
            yield put({type: FEEDBACK_QUALITY_GET_SUCCESS, optionalData});
        }
    } catch (e) {
        yield put({type: FEEDBACK_QUALITY_GET_FAILURE, error: e});
    }
}

function* qualityFeedbackSagaGet() {
    yield takeEvery(FEEDBACK_QUALITY_GET, qualityFeedbackSetData);
}

export default qualityFeedbackSagaGet;
